// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.q5dTAX_b6dnwNFA7YjsL .MuiFormControlLabel-label {
    font-size: 1em;
}

.Gz2JIgvJIouKuTeVWbWy {
    max-height: calc(100vh - 295px);
    margin-bottom: 20px;
    overflow: auto;
    /* fixes material checkbox 'splash' from getting cut off */
    padding-left: 20px;
    margin-left: -20px;
}

.e3w4fGoix0U_4nuT1JAH {
    display: flex;
    flex-direction: row-reverse;
}

._OamIPiXovGlmOl4HprB {
    padding-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests/interests-toolbar/download-form-modal.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,cAAc;IACd,0DAA0D;IAC1D,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".exportFormsModal :global(.MuiFormControlLabel-label) {\n    font-size: 1em;\n}\n\n.fields {\n    max-height: calc(100vh - 295px);\n    margin-bottom: 20px;\n    overflow: auto;\n    /* fixes material checkbox 'splash' from getting cut off */\n    padding-left: 20px;\n    margin-left: -20px;\n}\n\n.buttonContainer {\n    display: flex;\n    flex-direction: row-reverse;\n}\n\n.indentedCheckbox {\n    padding-left: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"exportFormsModal": `q5dTAX_b6dnwNFA7YjsL`,
	"fields": `Gz2JIgvJIouKuTeVWbWy`,
	"buttonContainer": `e3w4fGoix0U_4nuT1JAH`,
	"indentedCheckbox": `_OamIPiXovGlmOl4HprB`
};
export default ___CSS_LOADER_EXPORT___;
